// Record a visible, signed-in dashboard once per minute. Hidden tabs do not
// create heartbeats. An open tab crossing midnight gets a new dated record.
export function startDashboardActivity(send: () => Promise<unknown>) {
  let lastSent = -Infinity;
  const record = () => {
    if (document.visibilityState !== "visible" || Date.now() - lastSent < 60_000) return;
    lastSent = Date.now();
    void send().catch(() => { /* Retry at the next interval; do not disrupt work. */ });
  };
  record();
  const timer = window.setInterval(record, 60_000);
  document.addEventListener("visibilitychange", record);
  window.addEventListener("pageshow", record);
  return () => {
    window.clearInterval(timer);
    document.removeEventListener("visibilitychange", record);
    window.removeEventListener("pageshow", record);
  };
}
